export default __webpack_public_path__ + "static/media/handWithSensor.183c9783.jpg";